module.exports = __webpack_public_path__ + "static/media/03_chemi_poor.fc5508db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/intro-3/03_chemi_poor.png
// module id = 700
// module chunks = 0